import { useState } from 'react'

import TestimonialLeft from '../../../assets/images/landing-page/testimonial_left.png'
import TestimonialRight from '../../../assets/images/landing-page/testimonial_right.png'
import PersonOne from '../../../assets/images/landing-page/person_1.png'
import PersonTwo from '../../../assets/images/landing-page/person_2.png'

const testimonials = [
  {
    author: 'Orsolya Anna Tóth',
    message:
      'I think the biggest gain here is having an automated end-to-end process, where we know we are using generative AI ethically and content and creatives are labelled in the correct way, without us having to spend time, effort or thought on this process. We deeply appreciate the ease of use and how a very complex process can just run quietly in the background.',
  },
  {
    author: 'David Austerberry',
    message:
      'The TikBox platform offer a good alternative to the current route of licensing through a stock image library, especially if you want control of the client transactions. It also allows for direct transactions and licensing with a client without involving a stock library.',
  },
]

const TestimonialsMain = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(1)

  const changeTestimonial = (index) => {
    setActiveTestimonial(index)
  }

  return (
    <section
      className="tikbox-services testimonials-main"
      aria-label="TikBox testimonials"
    >
      <div className="testimonial">
        <img
          className="testimonial-bg-img left"
          src={TestimonialLeft}
          alt=""
          aria-hidden="true"
        />

        <img
          className="testimonial-bg-img right"
          src={TestimonialRight}
          alt=""
          aria-hidden="true"
        />

        <div className="tikbox-content">
          <h2>TESTIMONIALS</h2>

          <h3>Why users love TikBox</h3>

          <p>
            {testimonials[activeTestimonial]?.message}
          </p>

          <div
            className="photos animate__animated animate__fadeInUp"
            role="tablist"
            aria-label="Choose testimonial"
          >
            <button
              type="button"
              role="tab"
              aria-selected={activeTestimonial === 0}
              aria-label={`Show testimonial from ${testimonials[0].author}`}
              className={`photo${activeTestimonial === 0 ? ' active' : ''}`}
              onClick={() => changeTestimonial(0)}
            >
              <img
                src={PersonOne}
                alt={testimonials[0].author}
              />
            </button>

            <button
              type="button"
              role="tab"
              aria-selected={activeTestimonial === 1}
              aria-label={`Show testimonial from ${testimonials[1].author}`}
              className={`photo${activeTestimonial === 1 ? ' active' : ''}`}
              onClick={() => changeTestimonial(1)}
            >
              <img
                src={PersonTwo}
                alt={testimonials[1].author}
              />
            </button>
          </div>

          <p className="author-name">
            {testimonials[activeTestimonial]?.author}
          </p>
        </div>
      </div>
    </section>
  )
}

export default TestimonialsMain